/**
 * @desc 导出
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ProcurementOrderRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/export`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
